<template>
  <div class="navbar-background">

    <aside :class="{ 'router-links-mobile-open': isOpen, 'router-links-mobile-closed': !isOpen }">
      <!-- Mobile navbar -->
      <MobileNavbar :isOpen="isOpen" @update:isOpen="isOpen = $event" />
    </aside>

    <!-- Desktop navbar -->
    <div class="links-container">
      <!-- Hamburger button -->
      <div class="hamburger">
        <img @click="openMobileMenu" src="@/assets/navbar/hamburger.png" alt="Icon">
      </div>

      <DesktopNavbar/>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import MobileNavbar from '@/components/Navbar/MobileNavbar.vue';
import DesktopNavbar from '@/components/Navbar/DesktopNavbar.vue';

const isOpen = ref(false);

function openMobileMenu() {
  isOpen.value = !isOpen.value;
}

</script>

<style lang="scss" scoped>
@import '~/src/assets/css/NavbarStyle.scss';
</style>
